import { useEffect, useMemo, useState } from "react";
import { ActionBody, Column, TimeBody, DataTableClient, DateBody, ActionBodyWithIds } from "components/common/DataTable";
import { Dropdown, GridForm, Input } from "components/common/ListForm";
import { useHandleParamUrl } from "hooks/useHandleParamUrl";
import { classNames } from "primereact/utils";
import { MyCalendar } from "components/common/MyCalendar";
import { useListCustomerDetailWithState } from "modules/partner/service";
import { Button, Checkbox, DataTable, Dialog, Tag } from "components/uiCore";
import { useListEmployeeWithState } from "modules/employee/service";
import { Helper } from "utils/helper";
import { useListContractFileHasFileGia } from "modules/ContractFile/service";
import { Splitter, SplitterPanel } from "primereact/splitter";
import { listToast, statusOptions, typeDebit } from "utils";
import UpdateConfirmFileGia from "./update_confirm_debit_file_gia";
import { FilterMatchMode } from "primereact/api";
import { showToast } from "redux/features/toast";
import { useDispatch } from "react-redux";
import { confirmFileGiaByIdFileGia } from "../api";

// ✅ Component Header lọc dữ liệu
const Header = ({ _setParamsPaginator, _paramsPaginator,_selectedRows,_setSelectedRows,refreshHasFileGia }: any) => {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState({ name: "", customerDetailId: "" ,fromDate:Helper.lastWeekString(),toDate:Helper.toDayString()});
    const { data: customerDetails } = useListCustomerDetailWithState({status:1});
    // --- chuyển sang options bằng useMemo ---
    const customerOptions = useMemo(() => {
        if (!Array.isArray(customerDetails)) return [];
        return customerDetails.map((x: any) => ({
            label: x?.partners?.abbreviation ?? "(không tên)",
            value: x.id,
        }));
    }, [customerDetails]);
    useEffect(() => {
        // Mỗi khi filter thay đổi => cập nhật params
        _setParamsPaginator((prev: any) => ({
            ...prev,
            keyword: filter.name,
            customerDetailId : filter.customerDetailId,
            fromDate: filter.fromDate,
            toDate:filter.toDate,
        }));
    }, [filter]);
    async function DuyetFileGia(){
        const res = await confirmFileGiaByIdFileGia({ ids: _selectedRows, StatusConfirm: 1 });
        if (res.status === 200) {
          if (res.data.status) {
            dispatch(
              showToast({ ...listToast[0], detail: res.data.message })
            );
            refreshHasFileGia?.();
            _setSelectedRows([]);
          } else {
            dispatch(
              showToast({ ...listToast[2], detail: res.data.message })
            );
          }
        } else
          dispatch(
            showToast({ ...listToast[1], detail: res.data.message })
          );
    }
    async function HuyDuyetFileGia(){
        const res = await confirmFileGiaByIdFileGia({ ids: _selectedRows, StatusConfirm: 0 });
        if (res.status === 200) {
          if (res.data.status) {
            dispatch(
              showToast({ ...listToast[0], detail: res.data.message })
            );
            refreshHasFileGia?.();
            _setSelectedRows([]);
          } else {
            dispatch(
              showToast({ ...listToast[2], detail: res.data.message })
            );
          }
        } else
          dispatch(
            showToast({ ...listToast[1], detail: res.data.message })
          );
    }
    const items = [
      {
          label: 'Duyệt File Giá',
          icon: "pi pi-check-square",
          command: () => DuyetFileGia()
      },
      {
          label: 'Hủy Duyệt',
          icon: "pi pi-times-circle",
          command: () => HuyDuyetFileGia()
      }
    ];
    return (
        <GridForm
            paramsPaginator={_paramsPaginator}
            setParamsPaginator={_setParamsPaginator}
            filter={filter}
            setFilter={setFilter}
            className="lg:col-9"
            MenuItems={items}
            MenuIcon="pi pi-check-square"
            MenuName="Xác nhận"
        >
            <div className="col-2">
                <Input
                    value={filter.name}
                    onChange={(e: any) => setFilter({ ...filter, name: e.target.value })}
                    label="Tìm kiếm"
                    size="small"
                    className={classNames("input-sm")}
                />
            </div>
            <div className="col-2">
                <MyCalendar dateFormat="dd/mm/yy" 
                    value={filter.fromDate} 
                    onChange={(e: any) =>
                    setFilter({ ...filter, fromDate: e })}
                    className={classNames("w-full", "p-inputtext", "input-sm")} />
            </div>
            <div className="col-2">
                <MyCalendar dateFormat="dd/mm/yy"
                  value={filter.toDate} 
                  onChange={(e: any) =>
                  setFilter({ ...filter, toDate: e })}
                  className={classNames("w-full", "p-inputtext", "input-sm")} />
            </div>
            <div className="col-6">
                <Dropdown
                    filter
                    showClear
                    value={filter.customerDetailId}
                    options={customerOptions}
                    onChange={(e: any) => setFilter({ ...filter, customerDetailId: e.target.value })}
                    label="Khách hàng"
                    className={classNames("dropdown-input-sm", "p-dropdown-sm")}
                />
            </div>
        </GridForm>
    );
};

export default function ListConfirmFileGia() {
    const employeeInfo = localStorage.getItem('employeeInfo') ? JSON.parse(localStorage.getItem('employeeInfo') || '{}') : null;
    const { handleParamUrl } = useHandleParamUrl();
    const [selectedFileGiaRows, setSelectedFileGiaRows] = useState<any[]>([]);
    const [displayFileGia, setDisplayFileGia] = useState<any[]>([]);
    const [selectedDetail, setSelectedDetail] = useState<any[]>([]);
    const [selectedId, setSelectedId] = useState<any>();
    const [cfStatusConfirm, setCfStatusConfirm] = useState<any>();
    const [visible, setVisible] = useState(false);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(20);
    const [paramsPaginator, setParamsPaginator] = useState({
      pageNum: 1,
      pageSize: 20,
      first: 0,
      render: false,
      keyword: "",
      EmployeeId:employeeInfo?.id
    });
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        file_number: { value: null, matchMode: FilterMatchMode.CONTAINS },
        customerName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        customerAbb: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sales: { value: null, matchMode: FilterMatchMode.CONTAINS },
        container_code: { value: null, matchMode: FilterMatchMode.CONTAINS },
        declaration: { value: null, matchMode: FilterMatchMode.CONTAINS },
        bill: { value: null, matchMode: FilterMatchMode.CONTAINS },
        debit_cus_bill: { value: null, matchMode: FilterMatchMode.CONTAINS },
        cf_status_confirm: { value: null, matchMode: FilterMatchMode.EQUALS }
    });
    const { data: listFileGia,loading, refresh:refreshHasFileGia } = useListContractFileHasFileGia({ params: {...paramsPaginator,},debounce: 500,});
    const { data: listCustomer } = useListCustomerDetailWithState({status: 1});
    const { data: listEmployee } = useListEmployeeWithState({});
    const openDialogAdd = (id:number,cf_status_confirm:any) => {
        setSelectedId(id);
        setCfStatusConfirm(cf_status_confirm);
        setVisible(true);
    };
    const handleModalClose = () => {
      setVisible(false);
      refreshHasFileGia?.(); // reload debitDispatch
    };
    // ✅ Client-side pagination
    useEffect(() => {
        if (!listFileGia) return;
        handleParamUrl(paramsPaginator);
        // gom debits
         const dataArray = Array.isArray(listFileGia?.data) ? listFileGia.data : [];
         const groupedHasFileGia = Object.values(
            dataArray.reduce((acc:any, cur:any) => {
              const {debit_bill,debit_employee_staff_id,debit_service_id,debit_type,debit_id,debit_name,debit_updated_at,debit_updated_by,debit_status,debit_accounting_date,debit_purchase_price,debit_purchase_vat,debit_total_purchase_price,debit_price,debit_vat,debit_total_price,cf_note,cf_status,cf_status_confirm,cf_updated_at,cf_updated_by,debit_vehicle_number, ...rest } = cur;
              if (!acc[cur.id]) {
                acc[cur.id] = { ...rest, debits: [] ,debit_ids: [] };
              }
              // chỉ gom debit nếu debitService có dữ liệu
              if (listFileGia?.data) {
                acc[cur.id].debits.push({debit_bill,debit_employee_staff_id,debit_service_id,debit_type,debit_id,debit_name,debit_updated_at,debit_updated_by,debit_status,debit_accounting_date,debit_purchase_price,debit_purchase_vat,debit_total_purchase_price,debit_price,debit_vat,debit_total_price,cf_note,cf_status,cf_status_confirm,cf_updated_at,cf_updated_by,debit_vehicle_number});
                acc[cur.id].debit_ids.push(debit_id);
              }
              return acc;
            }, {} as Record<number, any>)
          );
          const mappedDebitFileGia = groupedHasFileGia.map((row: any) => {
            const _customer = listCustomer?.find((x: any) => x.id === row.customer_detail_id);
            const _employee = listEmployee.find((x: any) => x.id === row.employee_id);
            const _sumMua = row.debits.reduce((sum: number, x: any) => sum + (x.debit_total_purchase_price || 0), 0);
            const _sumBan = row.debits.reduce((sum: number, x: any) => sum + (x.debit_total_price || 0), 0);
            const cf_status_confirm = row.debits.find( (x: any) => x.cf_status_confirm === 0 || (x.cf_status_confirm === 1 && x.cf_status === 1) );
            console.log("cf_status_confirm",cf_status_confirm);
            return {
              ...row,
              customerName: _customer?.partners?.name || "",
              customerAbb: _customer?.partners?.abbreviation || "",
              employee: `${_employee?.last_name ?? ""} ${_employee?.first_name ?? ""}`.trim(),
              sumMua:_sumMua,
              sumBan:_sumBan,
              loiNhuan:_sumBan-_sumMua,
              cf_status_confirm:cf_status_confirm ? 0 : 1
            };
          });
         console.log(mappedDebitFileGia);
        setDisplayFileGia(mappedDebitFileGia);
    }, [first, rows,listFileGia, paramsPaginator,listCustomer]);
 
    return (
      <>
        <div className="card">
            <Header _paramsPaginator={paramsPaginator} _setParamsPaginator={setParamsPaginator}
            _selectedRows={selectedFileGiaRows}
            _setSelectedRows={setSelectedFileGiaRows}
            refreshHasFileGia={refreshHasFileGia} />
            <div style={{ height: 'calc(100vh - 8rem)' }}>
                 <Splitter layout="vertical" style={{ height: '100%', width: '100%' }}>
                    <SplitterPanel
                      size={75}
                      minSize={10}
                      style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                    >
                      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                         <b>Bảng theo dõi file giá</b>
                            <DataTableClient
                                rowHover
                                value={displayFileGia}
                                onPage={(e: any) => {
                                  setFirst(e.first);
                                  setRows(e.rows);
                                }}
                                loading={loading}
                                filters={filters}
                                onFilter={(e:any) => setFilters(e.filters)}
                                dataKey="id"
                                title="Tài khoản"
                                filterDisplay="row"
                                className={classNames("Custom-DataTableClient")}
                                scrollable
                                scrollHeight="flex"
                                style={{ flex: 1 }}
                                tableStyle={{ minWidth: "2000px" }}
                                onRowClick={(e: any) => {
                                    setSelectedDetail(e.data.debits)
                                }}
                              >
                                {/* Custom checkbox column */}
                                <Column
                                  header={
                                    <Checkbox
                                      checked={
                                        selectedFileGiaRows.length === displayFileGia.length &&
                                        displayFileGia.length > 0
                                      }
                                      onChange={(e: any) => {
                                        if (e.checked)
                                          setSelectedFileGiaRows(displayFileGia.map((d) => d.id));
                                        else setSelectedFileGiaRows([]);
                                      }}
                                    />
                                  }
                                  body={(rowData: any) => (
                                    <Checkbox
                                      className="p-checkbox-sm"
                                      checked={selectedFileGiaRows.includes(rowData.id)}
                                      onChange={(e: any) => {
                                        if (e.checked)
                                          setSelectedFileGiaRows((prev) => [...prev, rowData.id]);
                                        else
                                          setSelectedFileGiaRows((prev) =>
                                            prev.filter((id) => id !== rowData.id)
                                          );
                                      }}
                                      onClick={(e: any) => e.stopPropagation()} // ⚡ chặn row click
                                    />
                                  )}
                                  style={{ width: "3em" }}
                                />
                                  <Column
                                      header="Thao tác"
                                      body={(row: any) => {
                                        return <Button icon="pi pi-eye" rounded outlined className="mr-2"  onClick={() =>  openDialogAdd(row.id,row.cf_status_confirm)} />
                                      }}
                                  />
                                  <Column
                                    field="cf_status_confirm"
                                    header="Trạng thái"
                                    body={(row: any) => (
                                        row.cf_status_confirm === 1 ? (
                                             <Button label="Đã duyệt" rounded severity="success" size="small" text />
                                        ) : (
                                            <Button label="Chưa duyệt" rounded severity="warning" size="small" text />
                                        )
                                    )}
                                    filter
                                    filterElement={(options:any) => (
                                        <Dropdown
                                            value={options.value}
                                            options={statusOptions}
                                            onChange={(e:any) => {
                                              options.filterApplyCallback(e.value)
                                            }}
                                            label="trạng thái"
                                            className="p-column-filter"
                                            showClear
                                        />
                                    )}
                                    showFilterMenu={false}  style={{ width:"180px" }}/>
                                  <Column field="accounting_date" header="Ngày lập" body={(e: any) => DateBody(e.accounting_date)} filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="file_number" header="Số file" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="container_code" header="Số cont" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="customerName" header="Khách hàng" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="customerAbb" header="Tên viết tắt" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="sumMua" body={(row: any) => Helper.formatCurrency(row.sumMua.toString())}  header="Tổng mua" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="sumBan" body={(row: any) => Helper.formatCurrency(row.sumBan.toString())}  header="Tổng bán" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column field="loiNhuan" body={(row: any) => Helper.formatCurrency(row.loiNhuan.toString())}  header="Lợi nhuận" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column header="Người duyệt" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column header="Thời gian duyệt" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column header="Lý do duyệt" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column header="Người cập nhật" filter showFilterMenu={false} filterMatchMode="contains" />
                                  <Column header="Cập nhật lúc" body={(e: any) => TimeBody(e.updated_at)} />
                                </DataTableClient>
                      </div>
                    </SplitterPanel>
                    <SplitterPanel
                      size={25}
                      minSize={10}
                      style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
                    >
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                          <b>Chi tiết file giá</b>
                              <DataTable 
                              rowHover
                              scrollable
                              scrollHeight="flex"
                              style={{ flex: 1 }}
                              value={selectedDetail}
                              >
                                <Column body={(row: any) =>{
                                    return row?.file_number ? row.file_number : (row?.debits ? row.debits[0]?.file_number : "")
                                }} header="Số file" />
                                <Column field="debit_name" header="Chi phí" />
                                <Column field="debit_type"  body={(row: any) => typeDebit.find((x:any) => x.type === row.debit_type)?.name || ""} header="Loại chi phí" />
                                <Column body={(row: any) =>{
                                        const cus = listCustomer.find((x: any) => x.id === row.supplier_detail_id);
                                        return cus?.partners?.abbreviation || ""
                                    }} header="Nhà cung cấp" />
                                <Column field="debit_vehicle_number" header="Biển số" />
                                <Column field="debit_purchase_price" body={(row: any) => Helper.formatCurrency(row.debit_purchase_price.toString())} header="Giá mua" />
                                <Column field="debit_price" body={(row: any) => Helper.formatCurrency(row.debit_price.toString())} header="Giá bán" />
                                <Column field="debit_vat" header="VAT" />
                                <Column field="debit_total_price" body={(row: any) => Helper.formatCurrency(row.debit_total_price.toString())} header="Thành tiền" />
                                <Column field="debit_bill" header="Hóa đơn" />
                            </DataTable>
                        </div>
                    </SplitterPanel>
                 </Splitter>
            </div>
           
          </div>
          <Dialog
              position="top"
              dismissableMask
              header="Tạo file giá"
              visible={visible}
              onHide={() => setVisible(false)}
              style={{ width: "78vw" }}
            >
              <p className="m-0">
                {selectedId && <UpdateConfirmFileGia id={selectedId} status={cfStatusConfirm} onClose={handleModalClose} ></UpdateConfirmFileGia>}
              </p>
            </Dialog>
      </>
    );
}
